var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":"Add New Client"},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"ok":_vm.handleOk},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return cancel()}}},[_vm._v("Cancel")]),_c('b-button',{staticClass:"bg-site-primary",attrs:{"size":"sm","disabled":!_vm.isFormValid ? "disabled" : null,"variant":"primary"},on:{"click":function($event){return ok()}}},[_vm._v("Add")])]}}])},[_c('b-table',{attrs:{"stacked":"","borderless":true,"fields":[
        {
          key: 'username',
          label: 'Username'
        },
        {
          key: 'password',
          label: 'Password',
        },
        {
          key: 'confirmPassword',
          label: 'Confirm Password'
        } ],"items":[{
      username: _vm.username,
      password: _vm.password,
      confirmPassword: _vm.confirmPassword
    }]},scopedSlots:_vm._u([{key:"cell(username)",fn:function(){return [_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})]},proxy:true},{key:"cell(password)",fn:function(){return [_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]},proxy:true},{key:"cell(confirmPassword)",fn:function(){return [_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }